module.exports = __webpack_public_path__ + "static/media/serena.512d42c3.png";